<template>
    <page-loading v-if="loading"></page-loading>
    <vx-page-layout v-else :layout="props.campaignId ? 'sidebar' : 'create'">
        <template v-slot:title>
            <span v-if="!props.campaignId" class="inline-flex items-center gap-3">
                <font-awesome-icon widthAuto :icon="faFlagSwallowtail" class="text-base"></font-awesome-icon>
                <span>New Campaign</span>
            </span>
            <slot v-else name="header">{{ campaign.name }}</slot>
        </template>

        <template v-if="!props.campaignId" v-slot:description>
            Create blast and evergreen campaigns.
        </template>

        <template v-if="props.campaignId" v-slot:subtitle>
            <router-link :to="{ name: 'campaigns', query: route.query }"
               class="no-underline! text-sky-600! text-base font-normal">
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                All Campaigns
            </router-link>
        </template>

        <template v-if="props.campaignId" v-slot:sidebar>
            <page-sidebar :links="sidebarLinks"></page-sidebar>
        </template>

        <router-view></router-view>
    </vx-page-layout>
</template>

<script setup>
import { VxPageLayout } from '@voxie/frontend-components';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faFlagSwallowtail } from '@fortawesome/pro-solid-svg-icons';
import { computed, onMounted, onUnmounted, provide } from 'vue';
import { PAGE_HEADING_LEVEL } from '~/provides/pageHeadingLevel';
import { useRoute } from 'vue-router';
import PageLoading from '~/components/general/PageLoading.vue';
import { useCampaignDetails } from './useCampaignDetails';

const props = defineProps({
    campaignId: {
        type: Number,
        required: false,
    },
});

const route = useRoute();
provide(PAGE_HEADING_LEVEL, 'h2');

const { campaign, loading, mount, unmount } = useCampaignDetails();

onMounted(() => {
    mount(props.campaignId);
});

onUnmounted(() => {
    unmount();
});

const sidebarLinks = computed(() => [
    {
        to: { name: 'campaigns.edit', params: { id: props.campaignId } },
        label: 'Details',
    },
    {
        to: { name: 'campaigns.contacts', params: { id: props.campaignId } },
        label: 'Contacts',
    },
]);
</script>
